import { IContainer } from '../../interface/container';
import {
    injectAuthManager,
    injectMediaManager,
    injectUserStateManager,
} from '../../controller/interface/bind';
import { injectWorkspaceDB } from '../../db/interface/bind';
import { ISessionArgs, ISessionInstantiator } from '../interface/session';
import sessionInst from './session';
import { injectConfigAPI } from '../../interface';

function session(container: IContainer): ISessionInstantiator {
    const authInst = injectAuthManager(container);
    const mediaInst = injectMediaManager(container);
    const userInst = injectUserStateManager(container);
    const dbInst = injectWorkspaceDB(container);
    const configAPI = injectConfigAPI(container);

    return {
        ...sessionInst,
        open: (name: string) =>
            sessionInst.open(authInst, mediaInst, userInst, dbInst, configAPI, name),
        create: (name: string, args: ISessionArgs) =>
            sessionInst.create(authInst, mediaInst, userInst, dbInst, configAPI, name, args),
    };
}

export default session;
